import { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';

function DragList({ id, index, moveCard, item, actionButtons, state, handleSelection, deleteBottomAccess, addEditBottomAccess }) {
  const { selectedIdsArray } = state;
  const ref = useRef(null);
  const [{ handlerId }, drop] = useDrop({
    accept: 'card',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      // Get vertical indexdle
      const hoverindexdleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverindexdleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverindexdleY) {
        return;
      }
      // Time to actually perform the action
      moveCard(dragIndex, hoverIndex);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    },
  });
  const [, drag] = useDrag({
    type: 'card',
    item: () => {
      return { id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  drag(drop(ref));
  return (
    <tr key={index} ref={ref} data-handler-id={handlerId}>
      {deleteBottomAccess && (
        <td>
          <div className="checkbox-label no-label margin-auto">
            <input
              onChange={() => {
                handleSelection(item?._id);
              }}
              name={`checks_${index}`}
              id={`checks_${index}`}
              type="checkbox"
              checked={selectedIdsArray.filter((val) => val === item?._id).length > 0}
            />
            <label htmlFor={`checks_${index}`} className="chklabel">
              <span />
            </label>
          </div>
        </td>
      )}
      <td className="text-left">{item.channelName}</td>
      <td className="text-left text-capitalize">{item?.channelType === 'buyDependent' ? 'Buy Dependent' : item?.channelType}</td>
      <td className="text-left text-capitalize">{item.unit?.type || '--'}</td>
      <td className="text-left text-capitalize">{item.cost?.type || '--'} </td>
      {(addEditBottomAccess || deleteBottomAccess) && <td className="text-left">{actionButtons(item)}</td>}
    </tr>
  );
}
export default DragList;
